import clsx from 'clsx';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { VisualOverlayCSS } from './Visual.sty.js';

//#region Typings
/**
 * @public
 */
export interface VisualProps extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * Container for the Visual for the guided interaction overlays, e.g. an image or a video.
 * @public
 */
export const Visual = (props: VisualProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  return (
    <div
      data-testid={dataTestId}
      className={clsx(VisualOverlayCSS, consumerClassName)}
      style={consumerStyle}
    >
      {children}
    </div>
  );
};

Visual['displayName'] = 'GuidedInteraction.Visual';
